import { motion } from 'motion/react'
import { ReactNode } from 'react'

interface AnimatedSectionProps {
  children: ReactNode
  className?: string
  duration?: number
  yOffset?: number
}

// Animation variants for sections that fade in and slide up
// These work with parent AnimatedContainer's stagger timing
const sectionVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      ease: 'easeOut'
    }
  }
}

export function AnimatedSection({
  children,
  className,
  duration = 0.4,
  yOffset = 20
}: AnimatedSectionProps) {
  // Custom variants if duration or yOffset are provided
  const customVariants = duration !== 0.4 || yOffset !== 20 ? {
    hidden: {
      opacity: 0,
      y: yOffset
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration,
        ease: 'easeOut'
      }
    }
  } : sectionVariants

  return (
    <motion.div
      className={className}
      variants={customVariants}
    >
      {children}
    </motion.div>
  )
}
